import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bb2d908"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_2 = { class: "border rounded p-2" }
const _hoisted_3 = { class: "flex items-center mb-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "РЕЙС", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full border rounded my-4" }, null, -1))
const _hoisted_6 = { class: "flex items-center mb-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "НАПРАВЛЕНИЕ", -1))
const _hoisted_8 = { class: "w-full flex items-center justify-between gap-2 mt-2" }
const _hoisted_9 = { class: "border rounded p-2 overflow-y-scroll" }
const _hoisted_10 = { class: "flex items-center mb-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "СПИСОК НАКЛАДНЫХ", -1))
const _hoisted_12 = {
  key: 0,
  class: "flex flex-col items-center justify-center text-sm text-gray-400 select-none"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "Загрузка списка...", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "При получении списка произошла ошибка", -1))
const _hoisted_15 = { key: 2 }
const _hoisted_16 = {
  key: 1,
  class: "TtnsModalTable"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_18 = { class: "mt-2 flex items-center" }
const _hoisted_19 = { class: "w-full" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mb-3 text-sm text-gray-400" }, "Добавить накладную", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_trip_icon = _resolveComponent("trip-icon")!
  const _component_new_input = _resolveComponent("new-input")!
  const _component_direction_icon = _resolveComponent("direction-icon")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_invoices_icon = _resolveComponent("invoices-icon")!
  const _component_loader = _resolveComponent("loader")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_new_table = _resolveComponent("new-table")!
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_openBlock(), _createBlock(_component_new_modal, {
    title: `Редактировать ТТН №${_ctx.edit_state.ttnNumber}`,
    loading: _ctx.edit_state.is_loading,
    onSubmit: _ctx.editTtn,
    onCancel: _ctx.closeEdit,
    scrollable: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_trip_icon),
            _hoisted_4
          ]),
          _createVNode(_component_new_input, {
            placeholder: "Закреплена за рейсом",
            value: _ctx.edit_state.tripNumber,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.edit_state.tripNumber) = $event)),
            disabled: _ctx.edit_state.is_loading,
            "is-invalid": _ctx.edit_form$.tripNumber.$error,
            "validation-errors": _ctx.edit_form$.tripNumber.$errors
          }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_direction_icon),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_new_select, {
              class: "w-full",
              placeholder: "Город отправления",
              "can-deselect": "",
              "search-without-refresh": "",
              disabled: _ctx.cities_state.is_loading,
              loading: _ctx.cities_state.is_loading,
              failed: _ctx.cities_state.is_failed,
              options: _ctx.cities_state.list,
              value: _ctx.edit_state.fromCityId,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.edit_state.fromCityId) = $event)),
              onRefresh: _ctx.loadCities,
              "is-invalid": _ctx.edit_form$.fromCityId.$error
            }, null, 8, ["disabled", "loading", "failed", "options", "value", "onRefresh", "is-invalid"]),
            _createVNode(_component_new_select, {
              class: "w-full",
              placeholder: "Город назначения",
              "can-deselect": "",
              "search-without-refresh": "",
              disabled: _ctx.cities_state.is_loading,
              loading: _ctx.cities_state.is_loading,
              failed: _ctx.cities_state.is_failed,
              options: _ctx.cities_state.list,
              value: _ctx.edit_state.toCityId,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.edit_state.toCityId) = $event)),
              onRefresh: _ctx.loadCities,
              "validation-errors": _ctx.edit_form$.toCityId.$errors
            }, null, 8, ["disabled", "loading", "failed", "options", "value", "onRefresh", "validation-errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_invoices_icon),
            _hoisted_11
          ]),
          (
                        _ctx.edit_state.is_loading ||
                        _ctx.edit_state.is_failed ||
                        !_ctx.edit_state.ttnInvoices.length
                    )
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_ctx.edit_state.is_loading)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_loader, { class: "primary" }),
                      _hoisted_13
                    ], 64))
                  : (_ctx.edit_state.is_failed)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_14,
                        _createVNode(_component_new_button, {
                          class: "mt-1",
                          onClick: _ctx.loadTtn
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Перезагрузить ")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ], 64))
                    : (!_ctx.edit_state.ttnInvoices.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_15, "Список пуст"))
                      : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_new_table, {
                  columns: _ctx.INVOICES_TABLE_COLUMNS,
                  rows: _ctx.edit_state.ttnInvoices
                }, {
                  td: _withCtx(({ column, row }) => [
                    (column.key === 'invoiceNumber')
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: `/invoice/${row.invoiceId}`,
                          class: "text-blue-500",
                          target: "_blank"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(row.invoiceNumber), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                        ], 64))
                  ]),
                  actions: _withCtx(({ row }) => [
                    _createVNode(_component_new_button, {
                      class: "NewButton--small NewButton--red",
                      loading: _ctx.edit_state.is_loading,
                      disabled: _ctx.edit_state.is_loading,
                      onClick: ($event: any) => (_ctx.deleteInvoice(row.invoiceId)),
                      hint: "Удалить"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 2
                    }, 1032, ["loading", "disabled", "onClick"])
                  ]),
                  _: 1
                }, 8, ["columns", "rows"])
              ])),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_new_input, {
                placeholder: "Накладная",
                disabled: _ctx.edit_state.is_loading || _ctx.edit_state.is_invoice_loading,
                value: _ctx.edit_state.invoiceNumber,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.edit_state.invoiceNumber) = $event)),
                "is-invalid": _ctx.invoice_form$.invoiceNumber.$error,
                "validation-errors": _ctx.invoice_form$.invoiceNumber.$errors
              }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"])
            ]),
            _createVNode(_component_new_button, {
              class: "primary small ml-2 h-full",
              onClick: _ctx.addInvoice,
              loading: _ctx.edit_state.is_loading || _ctx.edit_state.is_invoice_loading
            }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            }, 8, ["onClick", "loading"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "loading", "onSubmit", "onCancel"]))
}